import { BillingModulePricesPage } from './BillingModulePricesPage';

export function PlansPage() {
  return <BillingModulePricesPage variant="primary" />;
}
